// index.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import esLocale from 'element-ui/lib/locale/lang/es'
import frLocale from 'element-ui/lib/locale/lang/fr'
import zh from './locale/zh-CN'
import en from './locale/en'
import de from './locale/de'
import es from './locale/es'
import fr from './locale/fr'
import { mtLegalContent } from './mtLegalContent'
import lptLegalContent from './lptLegalContent'
import brand from '@/branding'

Vue.use(VueI18n)

function mergeMessages(base, overrides) {
  return Object.keys(overrides || {}).reduce((result, key) => {
    const baseValue = result[key]
    const overrideValue = overrides[key]
    if (baseValue && overrideValue && typeof baseValue === 'object' && typeof overrideValue === 'object' && !Array.isArray(baseValue) && !Array.isArray(overrideValue)) {
      result[key] = mergeMessages({ ...baseValue }, overrideValue)
    } else {
      result[key] = overrideValue
    }
    return result
  }, { ...base })
}

const messages = {
  'zhCN': {
    ...mergeMessages(zh, brand.messages.zhCN),
    ...zhLocale
  },
  'zh': {
    ...mergeMessages(zh, brand.messages.zhCN),
    ...zhLocale
  },
  'en': {
    ...mergeMessages(en, brand.messages.en),
    ...enLocale
  },
  'de': {
    ...mergeMessages(de, brand.messages.de),
  },
  'es': {
    ...mergeMessages(es, brand.messages.es),
    ...esLocale
  },
  'fr': {
    ...mergeMessages(fr, brand.messages.fr),
    ...frLocale
  }
}

if (brand.id === 'mt') {
  messages.zhCN.legal = mtLegalContent
  messages.zh.legal = mtLegalContent
  messages.en.legal = mtLegalContent
  messages.de.legal = mtLegalContent
}

if (brand.id === 'lpt') {
  messages.zhCN.legal = lptLegalContent
  messages.zh.legal = lptLegalContent
  messages.en.legal = lptLegalContent
  messages.de.legal = lptLegalContent
}

const defaultLang = 'en'
if (!localStorage.getItem('lang')) {
  localStorage.setItem('lang', defaultLang)
}

let currentLang = localStorage.getItem('lang')
if (currentLang === 'zh') {
  currentLang = 'zhCN'
  localStorage.setItem('lang', 'zhCN')
}

const i18n = new VueI18n({
  locale: currentLang,
  messages,
  silentTranslationWarn: true,
  // English is the translation baseline for keys that are still pending in German/Chinese.
  fallbackLocale: 'en'
})

ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n
